import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationLinear: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAnimationLinear"><Path fillRule="evenodd" clipRule="evenodd" d="M21.3108 3.74999L3.75011 21.3106L2.68945 20.25L20.2501 2.68933L21.3108 3.74999Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAnimationLinear;
